import React from 'react';

import '../../Analyze.scss';

/**
 * Generic component for reference the report sub topic
 *
 * @param {*} props
 * @returns
 */
const SubTopic = (props) => {
  const {
    currentPageState,
    setCurrentSPageState,
    data,
    component,
    isLast,
  } = props;
  const { subPage, title, released } = data;

  /**
   * Get the sub menu class if needed.
   */
  const getSubMenuClass = () => {
    return `${
      currentPageState.subPage === subPage ? 'settings-click-sub-menu' : ''
    } ${isLast ? 'last' : ''}`;
  };

  /**
   * Get sub topic style for the cursor
   */
  const getPointerStyle = () => {
    return { cursor: released ? 'pointer' : 'default' };
  };

  /**
   * Call when the sub topic is clicked by user.
   */
  const onSubTopicSelected = () => {
    if (released) {
      setCurrentSPageState({ ...currentPageState, subPage, component });
    }
  };

  return (
    <div
      onClick={onSubTopicSelected}
      style={getPointerStyle()}
      className={`settings-tab-sub-menu-item ${getSubMenuClass()}`}
    >
      {title}
    </div>
  );
};

export default SubTopic;
